import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

export const dialog = Swal.mixin({
  customClass: { popup: 'artix-dialog', confirmButton: 'dialog-confirm', cancelButton: 'secondary-button' },
  buttonsStyling: false,
  reverseButtons: true,
});

export async function confirmAction(text: string) {
  const result = await dialog.fire({ title: 'Are you sure?', text, icon: 'warning', showCancelButton: true, confirmButtonText: 'Confirm', focusCancel: true });
  return result.isConfirmed;
}

export async function showError(error: unknown) {
  await dialog.fire({ title: 'Unable to complete action', text: error instanceof Error ? error.message : String(error), icon: 'error' });
}
